import { Component, ElementRef, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, catchError } from 'rxjs';
import { AgGridComponent } from '../../../../shared/common-components/ag-grid/ag-grid.component';
import { PaginationModel, AgGridI} from '../../../../shared/common-components/ag-grid/ag-grid.model';
import { AgGridService } from '../../../../shared/common-components/ag-grid/ag-grid.service';
import { DateRangeType, StorageName } from '../../../../shared/enum/common-enum';
import { ResponseModel } from '../../../../shared/models/response-model.model';
import { CommonService } from '../../../../shared/services/common.service';
import { SendDataService } from '../../../../shared/services/send-data.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { CustomerDetailsService } from '../../../../shared/common-components/common-voucher/popup/customer-details/customer-details.service';
import { ExcelConverterServiceService } from '../../../../shared/services/excel-converter-service.service';
import { CommonFilterService } from '../../../../shared/services/common-filter.service';
import { AgGridDataModelInstallmentReportList}from "../installment-report/installment-report.model"
import { AgGridDataModelInstallmentReportDetailsList}from "../installment-report/installment-report.model"
import { FileReaderService } from '../../../../shared/services/file.reader.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { ReportService } from '../../../../components/report/report.service';
import { InstallmentReportService}from '../installment-report/installment-report.service'
import { InstallmentAdvancefilterPopupComponent } from './installment-advancefilter-popup/installment-advancefilter-popup.component';
@Component({
  selector: 'app-installment-report',
  templateUrl: './installment-report.component.html',
  styleUrls: ['./installment-report.component.scss']
})
export class InstallmentReportComponent extends CommonService{
    formName = StorageName.FORMNAME_TRANSACTION_INSTALLMENT_REPORT;
    getLedgerRequestModel    : any = {};
    apiRequestModel : any = {};
    apistoragename = StorageName.APIREQUEST_TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID;
    apiInstallmentReportLedgerListstoragename = StorageName.APIREQUEST_TRANSACTION_INSTALLMENTREPORT_LEDGER_GRID;

    gridApiinstallmentreportDetailsList :any;
    gridApiInstallmentReportLedgerList : any;
    storageName = StorageName;
    pagination  = new PaginationModel();
    totalRecords : number;
    ledgerDetails:any = {};
    customerId: any;
    filterCountValue:any;
    @ViewChild('memoReportDetails_grid') memoReportDetails_grid: AgGridComponent;
    @ViewChild('fileUpload') fileUpload: ElementRef;
    @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>;
    agGridDataModelInstallmentReportList         : AgGridI;
    agGridDataModelInstallmentReportDetailsList  : AgGridI;
    getAllDropdownModel  : any = {};
    private toggleSubscription: Subscription;
  selectedRowId: any;
    constructor(
      public renderer: Renderer2,
      private sendDataService: SendDataService,
      private reportService: ReportService,
      private installmentReportService: InstallmentReportService,
      private router : Router,
      public storageService : StorageService,
      public agGridService:AgGridService,
      public fileReaderService : FileReaderService,
      public customerDetailsService:CustomerDetailsService,
      public toaster:ToastrService,
      private modalService : NgbModal,
      public notificationService: NotificationService,
      public excelConverterServiceService : ExcelConverterServiceService ,
      public commonFilterService    : CommonFilterService
    ) {
      super(renderer)
  
      this.toggleSubscription = this.sendDataService?.isUploadImage$.subscribe((value) => {
        if(value == true){
          this.getlistofschemesbyledgeridList();
        }
      });
      }
  
    ngOnInit(): void {
      this.agGridDataModelInstallmentReportList = AgGridDataModelInstallmentReportList;
      this.agGridDataModelInstallmentReportDetailsList = AgGridDataModelInstallmentReportDetailsList;
      this.sendDataService.displayPageName(this.formName);
    }
  
  
    onGridReady(event , gridName){
      switch(gridName){
        case(StorageName.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID):
        this.gridApiInstallmentReportLedgerList = event;
        this.getLedgerList(true);
        break ;
        case(StorageName.TRANSACTION_INSTALLMENTREPORT_DETAILS_GRID):
        this.gridApiinstallmentreportDetailsList = event;
        this.setDefaultFilter();
        break ;
      }
    }
  
    setDefaultFilter() {
      this.apiRequestModel.filters='';
      this.filterCountValue = 2;
      this.commonFilterService.setDefaultFilter(this.apistoragename, this.apiRequestModel, this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, { setDefaultDateRangePickerData: { dateRangeType: DateRangeType.FinancialYear, columnData: ['fromJoiningDate,toJoiningDate'] } });
      this.getlistofschemesbyledgeridList();
      this.commonFilterService.setDefaultFilter(this.apiInstallmentReportLedgerListstoragename, this.getLedgerRequestModel, this.agGridDataModelInstallmentReportList?.filterStorageName, { setDefaultDateRangePickerData: { dateRangeType: DateRangeType.FinancialYear, columnData: ['fromJoiningDate,toJoiningDate'] } });
      this.getLedgerList(true);
    }
    
    handleTextClick(event) {
      const data = event?.data;
      if (data) {
        this.navigateToInvoicePage(data?.voucherTypeId, data?.consignmentOutId, data?.stockJournalTypeId)
      }
    }
    
    onPrintButtonClick(params){
    const data = params?.detail?.data?.data
    this.reportService.printInvoices(data.voucherTypeId,data?.consignmentOutId);
    }
  
    rowClicked(event){
      const isDeleteCellClick = this.hasDeleteiconRendererClass(event?.event?.target);
     if(!isDeleteCellClick){
      this.gridApiInstallmentReportLedgerList?.api?.deselectAll();
      event?.node?.setSelected(true);
      const currentId = event?.data?.id;
      this.selectedRowId = event?.data?.id;  //
      if (currentId !== this.installmentReportService.previousrowClickedId) {
        this.installmentReportService.previousrowClickedId = currentId;
        this.selectedLedgerDetails(event?.node?.data)

      } else {
        
      }
     }
    }
  
    onDeleteIconClick(params){
      this.onDeleteRowClickedResponse(params?.detail?.data);
    }
  
    hasDeleteiconRendererClass(target: any): boolean {
       return target?.closest('.deleteicon') !== null;
     }
  
    addLedgerNavigate(){
      this.installmentReportService.sundryType = 'Sundry Creditors';
      this.router.navigate(['Product/ledger-opening'] );
    }
  
    selectedLedgerDetails(data){
      this.ledgerDetails = data;
      this.getlistofschemesbyledgeridList();
    }
  
    refreshGridApi(){
      this.gridApiinstallmentreportDetailsList?.api.refreshHeader();
      this.gridApiInstallmentReportLedgerList?.api.refreshHeader();
    }
  
    onDeleteRowClickedResponse(event) {
      this.deleteMemoReport(event?.data?.id);
    }
  
    callApiForExport(){
      const exportAs = this.apiRequestModel?.exportAs;
      if (this.ledgerDetails?.id == null){
        const LAYOUTDETAILS = this.storageService.retrieve(StorageName.LAYOUT_DETAILS); 
        const user = this.storageService.retrieve("user");
        if(LAYOUTDETAILS?.roleName !== 'Admin'){this.apiRequestModel.accountLedgerId = user?.accountLedgerId;}  
        else{
          this.commonFilterService?.performFilterColumnwise('accountLedgerId',[this.ledgerDetails?.id], undefined,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, 'textFilter');
          this.commonFilterService?.updateFilters(this.apiRequestModel,this.apistoragename,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName);        }
      }
      else{
        this.commonFilterService?.performFilterColumnwise('accountLedgerId',[this.ledgerDetails?.id], undefined,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, 'textFilter');
        this.commonFilterService?.updateFilters(this.apiRequestModel,this.apistoragename,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName);      }
      this.installmentReportService.getlistofschemesbyledgerid(this.apiRequestModel).subscribe(    
        {
          next: (res) => {
            this.fileReaderService.exportFile(res, exportAs);
           } ,error(error) {
              console.error('Error in downloading Excel/Pdf file:', error);
           },
         }
      )
    }

    
  
    // get all customer details list 
    getlistofschemesbyledgeridList(){
      this.showLoading(this.gridApiinstallmentreportDetailsList);
      if (this.ledgerDetails?.id == null){
        const LAYOUTDETAILS = this.storageService.retrieve(StorageName.LAYOUT_DETAILS); 
        const user = this.storageService.retrieve("user");
        if(LAYOUTDETAILS?.roleName !== 'Admin'){this.apiRequestModel.accountLedgerId = user?.accountLedgerId;}  
        else{
          this.commonFilterService?.performFilterColumnwise('accountLedgerId',[this.ledgerDetails?.id], undefined,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, 'textFilter');
          this.commonFilterService?.updateFilters(this.apiRequestModel,this.apistoragename,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName);

        }
      }
      else{
        this.commonFilterService?.performFilterColumnwise('accountLedgerId',[this.ledgerDetails?.id], undefined,  this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, 'textFilter');
          this.commonFilterService?.updateFilters(this.apiRequestModel,this.apistoragename,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName);
      }
      this.installmentReportService.getlistofschemesbyledgerid(this.apiRequestModel).subscribe({      
        next:(res)=>{
          if(res?.isSuccess){
            this.commonFilterService.processServersideApiResponse(res,this.grids?.first,this.gridApiinstallmentreportDetailsList,this.pagination,this.apiRequestModel?.getAll);
          }else{
            this.hideLoading(this.gridApiinstallmentreportDetailsList); 
            this.gridApiinstallmentreportDetailsList?.api?.setRowData([]);
          }
        },error:(err)=>{
          this.hideLoading(this.gridApiinstallmentreportDetailsList); 
          this.gridApiinstallmentreportDetailsList?.api?.setRowData([]);
        }
      })
    }
  
  // get all ledger list 
    getLedgerList(isOnInit=false){
      // this.commonFilterService.setDefaultFilter(this.apiInstallmentReportLedgerListstoragename, this.getLedgerRequestModel, this.agGridDataModelInstallmentReportList.filterStorageName, { setDefaultDateRangePickerData: { dateRangeType: DateRangeType.FinancialYear, columnData: ['fromJoiningDate,toJoiningDate','fromMaturityDate,toMaturityDate'] } });
      this.showLoading(this.gridApiInstallmentReportLedgerList);
      const user = this.storageService.retrieve("user");
      const LAYOUTDETAILS = this.storageService.retrieve(StorageName.LAYOUT_DETAILS); 
       const existingFilters = this.getLedgerRequestModel?.filters ? JSON?.parse(this.getLedgerRequestModel?.filters) : { rules: [], groups: [] };
        const rules = [{ data: user?.accountLedgerId ?? '', op: "eq", field: "ledgerId" }];
        existingFilters.rules = [...existingFilters?.rules, ...rules];
        if(LAYOUTDETAILS?.roleName !== 'Admin'){this.getLedgerRequestModel.filters = JSON?.stringify(existingFilters);}
      this.installmentReportService.getallinstallmentfundreportledgerlist(this.getLedgerRequestModel).subscribe({
        next:(res)=>{
          if(res?.isSuccess){
            this.totalRecords = res?.totalRecords;
            this.gridApiInstallmentReportLedgerList?.api?.setRowData(res?.response?.data);
            this.storageService.store(StorageName.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID_INITIAL_ROWS, res?.response?.data);
            this.refreshGridApi();
            if(isOnInit){
              if (this.selectedRowId) {
                const rowIndex = this.gridApiInstallmentReportLedgerList?.api
                    ?.getModel()?.rowsToDisplay?.findIndex(node => node?.data?.id === this.selectedRowId);
                this.gridApiInstallmentReportLedgerList?.api
                    ?.getDisplayedRowAtIndex(rowIndex || 0)?.setSelected(true);
            } else {
                const firstNode = this.gridApiInstallmentReportLedgerList?.api?.getDisplayedRowAtIndex(0);
                firstNode?.setSelected(true);
                if (!this.ledgerDetails?.id) this.selectedLedgerDetails(firstNode?.data);
            }
            
            };
           
          } else{
            this.hideLoading(this.gridApiInstallmentReportLedgerList); 
            this.gridApiInstallmentReportLedgerList?.api?.setRowData([]);
          }
        },error:(err)=>{
          this.hideLoading(this.gridApiInstallmentReportLedgerList); 
          this.gridApiInstallmentReportLedgerList?.api?.setRowData([]);
        }
      })
    }
  
    // delete customer list
    deleteMemoReport(id){
      this.customerDetailsService.deleteAccountLedger(id).pipe(catchError((err)=>this.handleError(err)))
          .subscribe((res: ResponseModel) => {
            if(res?.isSuccess===true){
              this.toaster.success(res?.message);
              this.getLedgerList(true);
            } else {
              this.toaster.error(res?.errors[0]);
            }
          })
     }
   

    navigateToInvoicePage(voucherTypeId: number, id: number,stockJournalTypeId : number) {
      this.reportService.navigateToInvoice(voucherTypeId , id , stockJournalTypeId);
    }
    
    
  getdatabyaccountLedgerId(id){
    if(id == 0 || id == undefined)
      return;
    this.customerDetailsService.getaccountledgerbyid(id).pipe(catchError((err)=>this.handleError((err))))
    .subscribe((res:ResponseModel)=>{        
      if(res.isSuccess){
            
            const data =res?.response;
            this.ledgerDetails.mobile  =data?.mobile;
            this.ledgerDetails.ledgerName = data?.ledgerName;
            this.ledgerDetails.email = data?.email;
            this.ledgerDetails.tradeNo = data?.gstNo;
          } 
        })
   }
  
   isCheckActive(){
    var data =  this.gridApiinstallmentreportDetailsList?.api?.getSelectedRows();
    return data?.some((x)=>x?.active)
   }
  
    navigateToSaleInvoice(){
      var data =  this.gridApiinstallmentreportDetailsList?.api?.getSelectedRows();
      const customerDetailsRow = data?.some((x)=>x?.active)
        if(customerDetailsRow) {
          this.storageService.store(StorageName.STORED_SELECTED_SALESORDER_FORSALEINVOICE,data );
          this.router.navigate(['/transaction/saleinvoice']);
        } 
    }
   
    navigateToConsignmentIn(){
      var data =  this.gridApiinstallmentreportDetailsList.api.getSelectedRows();
      const customerDetailsRow = data?.some((x)=>x?.active)
      if(customerDetailsRow) {
        this.storageService.store(StorageName.STORED_SELECTED_MEMOREPORT_FORCONSIGNMENTIN,data );
        this.router.navigate(['/inventory/consignment-in']);
      }
    }
  
    openAdvanceFilterPopUp(){
      var data = { getAllDropdownModel: this.getAllDropdownModel, agGridDataModel: this.agGridDataModelInstallmentReportDetailsList, apiRequestModel: this.apiRequestModel }
      this.notificationService.openModalPopup(InstallmentAdvancefilterPopupComponent, data, 'Advance Filter').then(
        (resultData) => {
          if (resultData) {
            this.apiRequestModel.filters = JSON?.stringify(resultData?.filters);
            this.commonFilterService?.performFilterColumnwise('accountLedgerId',[this.ledgerDetails?.id], undefined,  this.agGridDataModelInstallmentReportDetailsList?.filterStorageName, 'textFilter');
            this.commonFilterService?.updateFilters(this.apiRequestModel,this.apistoragename,this.agGridDataModelInstallmentReportDetailsList?.filterStorageName);
            const dateFilters = {
              ...resultData,
              rules: resultData?.filters?.rules?.filter(rules => 
                  ['fromJoiningDate', 'toJoiningDate', 'fromMaturityDate', 'toMaturityDate']?.includes(rules?.field)
              )
          };
            this.getLedgerRequestModel.filters= JSON?.stringify(dateFilters?.rules);
            this.storageService.store(this.apistoragename,this.apiRequestModel);
            this.storageService.store(this.apiInstallmentReportLedgerListstoragename,this.getLedgerRequestModel);
            this.filterCountValue = this.filterCount(resultData);
            this.getlistofschemesbyledgeridList();
            // this.getLedgerList(true);
          }
        }
      );
    }
  
    resetFilter(){
      this.setDefaultFilter();
      this.ledgerDetails.id =null;
      this.selectedRowId =null;
      this.installmentReportService.previousrowClickedId =0;
    }
    
  fillDropdownData() {
    this.getAllDropdownModel.schemeNameDropdown = this.storageService.retrieve(StorageName.SCHEME_NAME_DROPDOWN);
    this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
    this.getAllDropdownModel.redeemOnDropdown = this.storageService.retrieve(StorageName.REDEEM_ON_DROPDOWN)?.filter(x => x?.id !== "0");
    this.getAllDropdownModel.branchDropdown = this.storageService.retrieve(StorageName.BRANCH_DROPDOWN);
    this.getAllDropdownModel.durationTypeDropdown = this.storageService.retrieve(StorageName.DURATION_TYPE_DROPDOWN)?.filter(x => x?.id !== "0");
    this.getAllDropdownModel.installmentTypeDropdown =this.storageService.retrieve(StorageName.INSTALLMENT_TYPE_DROPDOWN)?.filter(x => x?.id !== "0");
    this.getAllDropdownModel.salePersonDropdown = this.storageService.retrieve(StorageName.SALEPERSON_DROPDOWN);

  }
    ngOnDestroy() {
    //  this.sendDataService?.headerPageNameAndInvoiceNum?.next(undefined);
      this.storageService.removeItem(StorageName.TRANSACTION_INSTALLMENT_REPORT_LEDGERLIST_GRID_INITIAL_ROWS);
      this.installmentReportService.previousrowClickedId  =0;
      this.toggleSubscription.unsubscribe();
  
    }
  
  }
  
